import { spacing } from "../tokens/spacing";

/**
 * Inject spacing tokens as CSS custom properties on the document root
 */
export const injectSpacing = () => {
  const root = document.documentElement;

  // Inject spacing values as CSS variables
  Object.entries(spacing).forEach(([key, value]) => {
    root.style.setProperty(`--spacing-${key}`, value);
  });
};
